export default "__VITE_ASSET__CXN_ELTn__"